import React from "react";

export default function Lightbox({ children, isDisplay, maxWidth }) {
  if (isDisplay) {
    return (
      <>
        <div
          id={"lightbox-black"}
          style={{
            position: "fixed",
            zIndex: "99",
            width: "100%",
            height: "100%",
            backgroundColor: "#000",
            opacity: "0.7",
            top: 0,
            left: 0
          }}
        >
          &nbsp;
        </div>
        <div
          style={{
            display: "flex",
            position: "fixed",
            width: "100%",
            height: "100%",
            zIndex: "99",
            top: 0,
            left: 0
          }}
        >
          <div style={{ margin: "auto", maxWidth }}>{children}</div>
        </div>
      </>
    );
  }

  return null;
}
